
namespace RioERP.Products {

    @Serenity.Decorators.registerClass()
    export class ProductTeacherShareDialog extends Serenity.EntityDialog<ProductTeacherShareRow, any> {
        protected getFormKey() { return ProductTeacherShareForm.formKey; }
        protected getIdProperty() { return ProductTeacherShareRow.idProperty; }
        protected getLocalTextPrefix() { return ProductTeacherShareRow.localTextPrefix; }
        protected getService() { return ProductTeacherShareService.baseUrl; }
        protected getDeletePermission() { return ProductTeacherShareRow.deletePermission; }
        protected getInsertPermission() { return ProductTeacherShareRow.insertPermission; }
        protected getUpdatePermission() { return ProductTeacherShareRow.updatePermission; }

        protected form = new ProductTeacherShareForm(this.idPrefix);

    }
}